import React, { useEffect, useState } from 'react';
import { Table } from '@veneer/table';
import { Pagination, Button, IconButton, Search, Select } from '@veneer/core';
import WarrantyPreferences from './WarrantyShipments.preferences';
import ConnectAPI from '../../../services/api';
import Swal from 'sweetalert2';
import moment from 'moment';
import { numberFormatComma } from './../../../common/js/utils/numberFormat';
import XLSX from 'xlsx';
import { Trans } from 'react-i18next';
import { translate } from 'react-i18next';
import Report from './Report';
const WarrantyShipments = (props) => {
  return <Report />;
};

export default WarrantyShipments;
